/*
 *
 * AllottedCasesDetailsPage constants
 *
 */

export const DEFAULT_ACTION = "app/AllottedCasesDetailsPage/DEFAULT_ACTION";
export const CASEDETAILS = "app/AllottedCases/CASEDETAILS";

export const SET_RERENDER = "app/AllottedCasesDetailsPage/SET_RERENDER";
